import React, { useEffect, useState } from 'react';

import { FaEye, FaDownload } from 'react-icons/fa';

import '../../styles/user/submittedVerification.css';

import {

  fetchSubmittedCandidates,

  fetchCandidateInfo,

  downloadReport

} from '../../services/user/api';

import ReportPage from './Report';

import { RotateCcw, Trash2, Search } from 'lucide-react';
 
const SubmittedVerificationPage = ({

  onViewFinalReport = () => {},

  onViewReport = () => {},

  onViewReportTwo = () => {},

}) => {

  const [candidates, setCandidates] = useState([]);

  const [fetchError, setFetchError] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);

  const [totalElements, setTotalElements] = useState(0);

  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState('');

  const [entriesPerPage, setEntriesPerPage] = useState(10);
 
  const loadSubmittedCandidates = async (page) => {

    try {

      setLoading(true);

      const response = await fetchSubmittedCandidates(page, entriesPerPage);

      if (response?.data?.status) {

        const data = response.data.data;

        setCandidates(data.content || []);

        setTotalElements(data.totalElements || 0);

      } else {

        setFetchError(response.data.message || 'Failed to fetch submitted candidates.');

      }

    } catch (error) {

      console.error('API Error:', error);

      setFetchError('An error occurred while fetching data.');

    } finally {

      setLoading(false);

    }

  };
 
  useEffect(() => {

    loadSubmittedCandidates(currentPage);

  }, [currentPage, entriesPerPage]);
 
 
 
  const getStatusClass = (status) => {

    switch (status?.toLowerCase()) {

      case 'verified':

        return 'status-tag verified';

      case 'completed':

        return 'status-tag completed';

      case 'work in progress':

        return 'status-tag work-in-progress';

      case 'login expired':

        return 'status-tag login-expired';

      case 'yet to start':

        return 'status-tag pending-submission';

      default:

        return 'status-tag';

    }

  };
 
  const filteredCandidates = candidates.filter((candidate) =>

    Object.values(candidate).some((value) =>

      String(value).toLowerCase().includes(search.toLowerCase())

    )

  );
 
  const totalPages = Math.ceil(totalElements / entriesPerPage);
 
  return (
<>
<p className="client-header">Submitted for Verification</p>
 
      <div className="client-wrapper">
<div className="clinet-table-controls">
<div className="entries-select">

            Show{' '}
<select

              value={entriesPerPage}

              onChange={(e) => {

                setEntriesPerPage(Number(e.target.value));

                setCurrentPage(0);

              }}
>
<option value="10">10</option>
<option value="25">25</option>
<option value="50">50</option>
</select>{' '}

            entries
</div>
<div className="client-search-box">
<div className="client-search-input-wrapper">
<input

                id="client-search-input"

                type="text"

                value={search}

                onChange={(e) => {

                  setSearch(e.target.value);

                  setCurrentPage(0);

                }}

                placeholder="Search by name"

              />
<Search className="client-search-icon" size={18} />
</div>
</div>
</div>
 
        {fetchError && <div className="error-message">{fetchError}</div>}
 
        <div className="clinet-table-container">

          {loading ? (
<div className="loading">Loading...</div>

          ) : (
<table className="candidates-clinet-table">
<thead>
<tr>
<th>Unique ID</th>
<th>Name</th>
<th>Email</th>
<th>Mobile Number</th>
<th>DOB</th>
<th>Case Initiated Date</th>
<th>Case Initiated Time</th>
<th>Status</th>
<th>Actions</th>
</tr>
</thead>
<tbody>

                {filteredCandidates.length > 0 ? (

                  filteredCandidates.map((candidate) => (
<tr key={candidate.candidateid}>
<td>{candidate.candidateid}</td>
<td>{candidate.fullname}</td>
<td>{candidate.email}</td>
<td>{candidate.mobileNumber}</td>
<td>{candidate.dateOfBirth}</td>
<td>{candidate.caseInitiatedDateOnlyAsString || 'N/A'}</td>
<td>{candidate.caseInitiatedTimeOnly || 'N/A'}</td>
<td>
<span className={getStatusClass(candidate.bgcStatus)}>

                          {candidate.bgcStatus || 'N/A'}
</span>
</td>
<td className="client-action-btn">
<button

                          className="client-action-btn"

                          onClick={() => onViewReportTwo(candidate.candidateid)}

                          title="View Report"
>
<FaEye />
</button>

</td>
</tr>

                  ))

                ) : (
<tr>
<td colSpan="9" className="no-data">

                      No matching candidates found.
</td>
</tr>

                )}
</tbody>
</table>

          )}
</div>
 
        {totalPages > 1 && (
<div className="pagination">
<div className="pagination-summary">

              Showing{' '}

              {totalElements === 0

                ? 0

                : currentPage * entriesPerPage + 1}{' '}

              to{' '}

              {Math.min((currentPage + 1) * entriesPerPage, totalElements)} of{' '}

              {totalElements} entries
</div>
<div className="pagination-buttons-user">
<button

                className="page-btn"

                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}

                disabled={currentPage === 0}
>

                ←
</button>
 
              {[...Array(totalPages)].map((_, i) => (
<button

                  key={i}

                  className={`page-btn ${currentPage === i ? 'active' : ''}`}

                  onClick={() => setCurrentPage(i)}
>

                  {i + 1}
</button>

              ))}
 
              <button

                className="page-btn"

                onClick={() =>

                  setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))

                }

                disabled={currentPage === totalPages - 1}
>

                →
</button>
</div>
</div>

        )}
</div>
</>

  );

};
 
export default SubmittedVerificationPage;

 